import { Component, OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import * as Highcharts from "highcharts";
import { Options } from "highcharts";
import { menulist } from "../class/status";
import { page } from "../class/status";
import { chartdata } from "../class/chatdata";
import { environment } from "../../../environments/environment";
import { Rtable } from "../class/rtabledata";
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.css"],
})
export class HomeComponent implements OnInit {
    Highcharts: typeof Highcharts = Highcharts;
    now: string = "0";
    action: number = 0;
    msgViewPeople: boolean = false; // 訊息紀錄(action=4) 顯示模式：true=發送對象人數、false=訊息則數
    consume: any = [];
    updateFlag:boolean=false;
    menu_list: menulist = [
        { id: "0", name: "每日數據" },
        { id: "1", name: "月收支折線圖" },
        { id: "4", name: "月會員儲值率" },
        { id: "2", name: "月會員消費項目" },
        { id: "3", name: "月會員活動" },
        { id: "5", name: "月登入轉換率" },
        { id: "9", name: "營運分析" },
    ];
    analysis_reports: any = [];
    analysis_loading: boolean = false;
    analysis_view: string = "platform";   // 營運分析子視圖:platform=運營面、users=個別用戶面
    data: any = [];
    third_data: any = [];
    edit_data: any = [];
    money_info: any = [];
    login_info: any = [];
    detail_info: any = [];
    ratio_info: any = [];
    deposit_info: any = [];
    info: any = [];
    show_time: string = "每日明細";
    loading: boolean = false;
    pageobj: page = { page: 0, count: 7, total_count: 0 };
    pageobj2: page = { page: 0, count: 20, total_count: 0 };
    pageobjstr: string = JSON.parse(JSON.stringify(this.pageobj));
    pageobjstr2: string = JSON.parse(JSON.stringify(this.pageobj2));
    pageobj3: page = { page: 0, count: 10, total_count: 0 };
    pageobjstr3: string = JSON.parse(JSON.stringify(this.pageobj3));
    tmd_para: any = { time_id: "-1", action: 0 };
    tcontent =[
        {title:'日期',content:'target_date'},
        {title:'儲值',content:'deposit_twd_all',sort:'deposit_twd_all',type:3,css:'min-width: 80px;'},
        {title:'提領',content:'withdrawal_twd',type:3},
        {title:'註冊人數',content:'regist_info',type:3},
        {title:'文字',content:'msg_info',sort:'text_diamond_all'},
        {title:'語音',content:'voice_info',sort:'voice_diamond_all'},
        {title:'視訊',content:'video_info',sort:'video_diamond_all'},
        {title:'解鎖',content:'delock_info',sort:'delock_diamond_all'},
        {title:'送禮',content:'gift_info',sort:'gift_diamond_all'},
        {title:'打賞',content:'chat_donate_info',sort:'chat_donate_diamond_all'},
        {title:'直播',content:'live_info',sort:'live_diamond_all'},
        {title:'註冊即儲值',content:'new_user_deposit_all',sort:'new_user_deposit_all',type:3,css:'min-width: 140px;'},
        {title:'互動',content:'interactive_diamond_male',sort:'interactive_diamond_male'},
    ];

    tcontent1 =[
        {title:'用戶',content:'name',type:2},
        {title:'鑽石',content:'diamond',type:3,sort:'diamond'},
        {title:'註冊時間',content:'create_dt',sort:'create_dt'},
        {title:'收到訊息數',content:'get_text_num',type:3,sort:'get_text_num'},
        {title:'語音通訊筆數',content:'voice_num',type:3,sort:'voice_num'},
        // user.is_hidden：1 = 被後台隱藏（不會出現在配對/推薦），0 = 正常。
        // 後端 add_user_data 是 SELECT * FROM user，這欄本來就在回傳裡，不用改查詢；
        // 排序要另外把 is_hidden 加進 sort_detail_users 的白名單才有效。
        {title:'是否隱藏',content:'is_hidden',sort:'is_hidden',replaceArr:{0:'否',1:'是'}},
    ];

    // 訊息紀錄(action=4)。與 tcontent1 同一套 app-table-v2 模板。
    // total=訊息則數、people=發給幾個不同的人；OS / 地區 / 註冊時間 三欄後端 action=4 現在也帶了
    // (os_type / country=地區名 / create_dt，欄位名與 tcontent1 對齊；2026-09-15 老闆反映發送那張少這三欄)。
    // 排序欄位要在後端 sort_detail_users 的白名單內才有效，country 那邊是字串比。
    tcontent_msg =[
        {title:'用戶',content:'name',type:2},
        {title:'訊息數',content:'total',type:3,sort:'total'},
        {title:'對象人數',content:'people',type:3,sort:'people'},
        {title:'OS',content:'os_type',type:3,sort:'os_type'},
        {title:'地區',content:'country',sort:'country'},
        {title:'註冊時間',content:'create_dt',sort:'create_dt'},
    ];

    // 註冊用戶(action=2)。與 tcontent1 同一套模板。列是 SELECT * FROM user 再補
    // has_deposit=區間內儲值鑽數（deposit_record 彙總）、country=地區名（後端 action=2 補，2026-09-15）、
    // get_text_num=區間內收到的訊息數（2026-09-16 補；後端 fill_received_text_num，與上線未聊天同一支，點數字可下鑽看誰傳的）。
    // 排序欄位要在後端 sort_detail_users 白名單內（has_deposit / get_text_num 都在）。
    tcontent_reg =[
        {title:'用戶',content:'name',type:2},
        {title:'鑽石',content:'diamond',type:3,sort:'diamond'},
        {title:'期間儲值',content:'has_deposit',type:3,sort:'has_deposit'},
        {title:'收到訊息數',content:'get_text_num',type:3,sort:'get_text_num'},
        {title:'註冊時間',content:'create_dt',sort:'create_dt'},
        {title:'OS',content:'os_type',type:3,sort:'os_type'},
        {title:'地區',content:'country',sort:'country'},
        {title:'是否隱藏',content:'is_hidden',sort:'is_hidden',replaceArr:{0:'否',1:'是'}},
    ];

    // 刪除人員(action=6，2026-09-16)。與 tcontent1 同一套模板；列是 SELECT * FROM user WHERE phone_num<0，
    // update_dt 就是刪除時間；get_text_num / voice_num 是刪除前那段區間收到的訊息與被打進來的通話（後端同 7/8 那兩支 fill_*）。
    tcontent_del =[
        {title:'用戶',content:'name',type:2},
        {title:'鑽石',content:'diamond',type:3,sort:'diamond'},
        {title:'收到訊息數',content:'get_text_num',type:3,sort:'get_text_num'},
        {title:'語音通訊筆數',content:'voice_num',type:3,sort:'voice_num'},
        {title:'註冊時間',content:'create_dt',sort:'create_dt'},
        {title:'刪除時間',content:'update_dt',sort:'update_dt'},
        {title:'OS',content:'os_type',type:3,sort:'os_type'},
        {title:'地區',content:'country',sort:'country'},
        {title:'是否隱藏',content:'is_hidden',sort:'is_hidden',replaceArr:{0:'否',1:'是'}},
    ];

    tcontent2 =[
        {title:'用戶',content:'name',type:2},
        {title:'儲值金額',content:'deposit_twd',sort:'deposit_twd',type:3,css:'min-width: 140px;'},
        {title:'最後上線時間',content:'last_singin_date',sort:'last_singin_date'},
        {title:'最後收到訊息時間',content:'last_chat_dt',sort:'last_chat_dt'},
    ];
    gender_type =[
        {id:0,name:'全部'},
        {id:1,name:'男'},
        {id:2,name:'女'}
    ];

    gender_type_num:number = 0;
    time_id:string = '-1';
    sort_obj:any = {column:'target_date',sort:'0'}
    sort_obj_detail:any = {column:'',sort:'0'}

    // 「收到訊息數」點下去的下鑽畫面。刻意做在同一個 modal 裡切換而不是再開一層 modal，
    // Bootstrap 疊 modal 的 backdrop / z-index 很容易出問題。
    // 分頁在後端做(SQL LIMIT)：rows 只有當頁 20 筆，翻頁重打 API；total_count=傳訊者總數
    msgDetail:any = {open:false,loading:false,user:null,rows:[],pageobj:{page:0,count:20,total_count:0},total:0,real:0,mass:0,read:0};
    sort_obj_NoMsgdata:any = {column:'deposit_twd',sort:'0'}

    constructor(public httpClient: HttpClient , private router: Router) {}
    content: string = "accuse";
    link: string = environment.link;

    noMsgWhaleCount: number | null = null;
    noMsgWhaleList = [];

    rangeStart = ''; // 'YYYY-MM-DD'
    rangeEnd = '';   // 'YYYY-MM-DD'
    isRangeValid = true;
    get_no_msg_whales:number = 0;
    noMsgWhalKeyword = '';
    noMsgWhalKeywordTmp = '';
    filterType: 'all' | 'online' = 'online';
    minDate!: string;
    maxDate!: string;

    pushMsg(type?: number) {
        // TODO: 實作推播功能
        console.log('推播', type);
        this.openNoMsgWhaleModal(type);

    }

    changeFilterType(value){
        this.filterType = value;
        this.pageobj3 = { page: 0, count: 10, total_count: 0 };
        this.applyRange();
    }

    onNoMsgWhalSearch(){
        this.noMsgWhalKeyword = this.noMsgWhalKeywordTmp;
        this.pageobj3 = { page: 0, count: 10, total_count: 0 };
        this.openNoMsgWhaleModal();
    }

    openNoMsgWhaleModal(type = 0){
        // this.loading = true;
        const body = {type:type,filterType:this.filterType,keyword:this.noMsgWhalKeyword,sort_obj_NoMsgdata:this.sort_obj_NoMsgdata,pageobj:this.pageobj3,rangeStart:this.rangeStart,rangeEnd:this.rangeEnd,action:1};
        this.httpClient.post<any>("/v1/common/get_no_msg_whales.php",body).subscribe(res => {
            this.loading = false;
            if(type != 2){
                this.noMsgWhaleList = res.data;
                this.pageobj3.total_count = res.total;
                this.pageobjstr3 = JSON.parse(JSON.stringify(this.pageobj3));
            }
        }, error => {
            console.log(error);
        });
    }

    handlesortNoMsgdata( value: any ): void {
        this.pageobj3 = { page: 0, count: 10, total_count: 0 };
        this.sort_obj_NoMsgdata = value;
        this.openNoMsgWhaleModal();
    }


    handlesortdata( value: any ): void {
        this.sort_obj = value;
        this.init_list();
    }

    openMsgDetail( user: any ): void {
        if(!user || !user.uid || !(user.get_text_num > 0)){
            return;
        }
        this.msgDetail = {open:true,loading:true,user:user,rows:[],pageobj:{page:0,count:20,total_count:0},total:0,real:0,mass:0,read:0};
        this.loadMsgDetail();
    }

    loadMsgDetail(): void {
        this.msgDetail.loading = true;
        const body = {
            uid: this.msgDetail.user.uid,
            date_type: this.tmd_para.time_id,
            page: this.msgDetail.pageobj.page,
            count: this.msgDetail.pageobj.count,
        };
        this.httpClient.post<any>("/v1/common/get_received_msg_detail.php", body).subscribe((res) => {
            this.msgDetail.loading = false;
            if(res.status){
                this.msgDetail.rows  = res.data || [];
                this.msgDetail.total = res.total || 0;
                this.msgDetail.real  = res.real || 0;
                this.msgDetail.mass  = res.mass || 0;
                this.msgDetail.read  = res.read || 0;
            }else{
                this.msgDetail.rows = [];
            }
            // 換新物件才會觸發 app-pagnation 的 ngOnChanges 重算頁數
            this.msgDetail.pageobj = {...this.msgDetail.pageobj, total_count: res.total_count || 0};
        }, () => {
            this.msgDetail.loading = false;
            this.msgDetail.rows = [];
        });
    }

    closeMsgDetail(): void {
        this.msgDetail.open = false;
    }

    callbackMsgDetail(pageobj: page): void {
        if (JSON.stringify(this.msgDetail.pageobj) != JSON.stringify(pageobj)) {
            this.msgDetail.pageobj = pageobj;
            this.loadMsgDetail();
        }
    }

    // action 7/8 的 modal 專用。不能沿用 handlesortdata，那支會去重載外層首頁表格而不是 modal。
    // 升/降冪的切換必須自己記：fuck_view() 會把 edit_data/consume 清空，外層 *ngIf 隨即為 false，
    // app-table-v2 整個被銷毀重建，它內部的 sort_obj 會回到初始值，所以它每次都只會送出降冪。
    handlesortdetail( value: any ): void {
        const column = value?.column;
        if(!column){
            return;
        }
        const same = this.sort_obj_detail.column === column;
        this.sort_obj_detail = {
            column: column,
            sort: same ? (this.sort_obj_detail.sort === '0' ? '1' : '0') : '0',
        };
        this.pageobj2.page = 0;
        this.fuck_view(this.tmd_para.time_id, this.tmd_para.action);
    }

    ngOnInit(): void {
        this.routerdefault();
        this.init_list();

        // 預設：本月 1 號 ~ 今天（你也可以換成你想要的）
        const today = new Date();
        const start = new Date(today.getFullYear(), today.getMonth(), 1);

        const fmt = (d: Date) => d.toISOString().slice(0, 10);
        this.rangeStart = fmt(start);
        this.rangeEnd = fmt(today);

        this.validateRange();
        this.applyRange();


        // max = 今天
        this.maxDate = this.formatDate(today);

        // min = 半年前
        const halfYearAgo = new Date();
        halfYearAgo.setMonth(today.getMonth() - 6);
        this.minDate = this.formatDate(halfYearAgo);


    }

    lineOptions: Options = chartdata.line;
    pieOptions: Options = chartdata.pie;

    // yyyy-mm-dd
    formatDate(date: Date): string {
      return date.toISOString().slice(0, 10);
    }


    onRangeChange() {
        this.validateRange();
    }

    validateRange() {
        if (!this.rangeStart || !this.rangeEnd) {
            this.isRangeValid = false;
            return;
        }

        // 1️⃣ 結束日不能早於開始日
        if (this.rangeEnd < this.rangeStart) {
            this.isRangeValid = false;
            return;
        }

        // 2️⃣ 半年內限制（開始日 ~ 結束日 不可超過 6 個月）
        const start = new Date(this.rangeStart);
        const end = new Date(this.rangeEnd);

        const limitEnd = new Date(start);
        limitEnd.setMonth(limitEnd.getMonth() + 6);

        if (end > limitEnd) {
            this.isRangeValid = false;
            return;
        }

        this.isRangeValid = true;
    }

    resetRange() {
        const today = new Date();
        const start = new Date(today.getFullYear(), today.getMonth(), 1);
        const fmt = (d: Date) => d.toISOString().slice(0, 10);
        this.rangeStart = fmt(start);
        this.rangeEnd = fmt(today);
        this.validateRange();
        this.applyRange();
    }

    async applyRange() {
        this.validateRange();
        if (!this.isRangeValid) return;
        this.loading = true;
        try {
            //把名單列表的分頁重置
            this.pageobj3 = { page: 0, count: 10, total_count: 0 };
            const body = {filterType:this.filterType,rangeStart:this.rangeStart,rangeEnd:this.rangeEnd,action:0};
            this.httpClient.post<any>("/v1/common/get_no_msg_whales.php",body).subscribe(res => {
                this.loading = false;
                this.noMsgWhaleCount = res.data;
            }, error => {
                console.log(error);
            });

        } finally {
            this.loading = false;
        }
    }


    routerdefault(){
        this.loading = true;
        const body = {};
        this.httpClient.post<any>("/customer_service/get_menu_list.php",body).subscribe(res => {
            this.loading = false;
            const url = res.data[0]?.subitem[0]?.url;
            if(url !== 'home'){
                window.location.href = '/admin_rtc/' + url;
            }
        }, error => {
            console.log(error);
        });
    }

    fuck_view(time_id: string, action: number) {
        this.pageobj2.total_count = 0;
        this.tmd_para = { time_id: time_id, action: action };
        // time_id 存成欄位：原本只有 action 7/8 的 click 會設它，action 4 的性別下拉要重打 API 時
        // 沒有正確的 time_id 可用（會拿到上一次的 -1 或別張卡的值）。統一在這裡同步。
        this.time_id = time_id;
        this.edit_data = [];
        this.consume = [];
        this.action = action;
        this.msgDetail.open = false; // 換視角/換頁時退回名單，避免停在上一個人的明細
        const time_list = ["今天", "昨日", "過去一周", "過去一個月"];
        const action_list = [
            "儲值用戶",
            "提領用戶(不呈現經紀提領)",
            "註冊用戶",
            "消費紀錄",
            "訊息紀錄",
            "簡訊發送紀錄",
            "刪除人員紀錄",
            "上線未傳訊息人員紀錄",
            "上線人員紀錄",
        ];
        this.show_time = `${time_list[time_id]}${action_list[action]}`;
        const body = {
            date_type: time_id,
            action: action,
            page: this.pageobj2.page,
            count: this.pageobj2.count,
            gender_type_num:this.gender_type_num,
            msg_view_people: this.msgViewPeople ? 1 : 0, // action=4：1=依對象人數排序、0=依則數排序
            sort_column: this.sort_obj_detail.column,    // action=7/8 名單排序，後端在切頁前套用
            sort_type: this.sort_obj_detail.sort,
        };
        this.loading = true;
        this.httpClient.post<any>("/v1/common/fucking_tmd_statistics_detail.php", body).subscribe((res) => {
            this.loading = false;
            if (res.status) {
                console.log('res.data',res.data);
                this.edit_data = res.data;
                this.consume = res.consume;
                this.pageobj2.total_count = res.total_count;
            } else {
                this.edit_data = [];
                this.consume = [];
                this.pageobj2.total_count = 0;
            }
            this.pageobjstr2 = JSON.parse(JSON.stringify(this.pageobj2));
            console.log("res", res);
        });
    }

    init_list(action = 0) {
        const body = {
            page: this.pageobj.page,
            count: this.pageobj.count,
            action: action,
            now_action:this.now,
            sort_obj:this.sort_obj,
        };
        this.loading = true;
        this.httpClient.post<any>("/v1/common/get_statistics.php", body).subscribe((res) => {
            this.loading = false;
            if(res.status == 'error'){
                Swal.fire(res.message, "", "error");
                return;
            }
            if(this.now == "0"){
                this.third_data = res.third_info;
                if (res.status) {
                    this.data = res.data;
                    this.info = res.stastics_info;
                    // this.money_info = res.money_info;
                    this.login_info = res.login_info;
                    this.detail_info = res.detail_info;
                    this.ratio_info = res.ratio_info;
                    this.deposit_info = res.deposit_info;
                    this.pageobj.total_count = res.total_count;
                    // 載入完成自動拉一次即時拆分數字，讓「純真實/純群發/兩者皆發」與「真實/群發」預設就顯示
                    this.refreshAllRealtimeStats();
                } else {
                    this.pageobj.total_count = 0;
                    this.data = [];
                    this.info = [];
                    // this.money_info = res.money_info;
                    this.login_info = res.login_info;
                    this.detail_info = res.detail_info;
                    this.ratio_info = res.ratio_info;
                    this.deposit_info = res.deposit_info;
                }
                this.pageobjstr = JSON.parse(JSON.stringify(this.pageobj));
            }else{
                this.draw_chat(res.return,this.now)
            }
        });
    }

    draw_chat(data,now){
        let categories = data.categories;
        let series = data.series;
        if(now == '2'){
            this.pieOptions.title.text = data.title;
            this.pieOptions.series = series;
        }else{
            this.lineOptions.title.text = data.title;
            this.lineOptions.xAxis = { categories: categories };
            this.lineOptions.series = series;
        }
        this.updateFlag = true;
    }

    choose(value: string) {
        this.now = value;
        if (value == "9") {
            this.loadAnalysis();
            return;
        }
        this.init_list();
    }

    // 分類色彩/中文標籤(語意色,和主題 accent 分開;報告卡片、名單圖表共用)
    private static CATEGORY_COLOR: { [k: string]: string } = {
        value_male: '#2f6fed',
        value_female: '#e0559b',
        decay: '#e2703a',
        dormant: '#8b2942',
        flash_risk: '#b8860b',
        other: '#8a93a6',
    };
    private static CATEGORY_LABEL: { [k: string]: string } = {
        value_male: '男性價值用戶',
        value_female: '女性價值用戶',
        decay: '花費下滑',
        dormant: '沉睡大戶',
        flash_risk: '快閃流失風險',
        other: '其他',
    };
    private static TYPE_LABEL: { [k: string]: string } = {
        value_users: '男女生價值用戶',
        decay: '花費下滑',
        male_lifecycle: '男生生命週期',
        ops: '營運狀況',
        composite: '綜合分析',
        other: '其他',
    };
    // 大戶動能儀錶板分類(確定性計算,DuckDB 產出,非 LLM 名單)
    private static WHALE_LABEL: { [k: string]: string } = {
        whale_growth: '高成長大戶',
        whale_decline: '衰退大戶',
        whale_new: '新進大戶',
        whale_dormant: '沉睡大戶',
    };
    private static WHALE_COLOR: { [k: string]: string } = {
        whale_growth: '#2f9e58',
        whale_decline: '#e2703a',
        whale_new: '#2f6fed',
        whale_dormant: '#8b2942',
    };
    whaleLabel(c: string): string { return HomeComponent.WHALE_LABEL[c] || c; }
    whaleColor(c: string): string { return HomeComponent.WHALE_COLOR[c] || '#8a93a6'; }

    // 大戶動能儀錶板的「動能」欄。成長率是 後半÷前半,前半為 0 就除不下去(growth_pct=null),
    // 不能印 +∞%,所以要換個字。但「前半 0」有兩種完全不同的情況:
    //   老用戶沉寂一陣子後回來  → 回歸
    //   區間內才註冊的新用戶    → 他前半當然是 0(那時還沒這個人),叫「回歸」是誤導
    // 2026-09-14 實測那份報告 5 筆顯示「回歸」,只有 1 筆是真的回歸,其餘 4 筆是 8/22~9/06 才註冊的新用戶。
    // 判斷依據用註冊日與報表區間起點比:區間內註冊的一律算新進。
    momentumLabel(w: any, r: any): string {
        if (w && w.growth_pct !== null && w.growth_pct !== undefined)
            return (w.growth_pct > 0 ? '+' : '') + w.growth_pct + '%';
        if (!(w && w.first_half_spend == 0 && w.second_half_spend > 0)) return '-';
        return this.isNewInPeriod(w, r) ? '新進' : '回歸';
    }
    momentumColor(w: any, r: any): string {
        if (w && w.growth_pct !== null && w.growth_pct !== undefined)
            return w.growth_pct >= 0 ? '#2f9e58' : '#c0392b';
        if (!(w && w.first_half_spend == 0 && w.second_half_spend > 0)) return '#8a93a6';
        return this.isNewInPeriod(w, r) ? '#2f6fed' : '#2f9e58';   // 新進用藍(同新進大戶)、回歸用綠
    }
    // 註冊日落在報表區間內 = 這個區間才出現的新用戶。區間抓不到就保守當成「不是新進」。
    private isNewInPeriod(w: any, r: any): boolean {
        const reg = String((w && w.register_date) || '').slice(0, 10);
        const start = String((r && r.period_start) || '').slice(0, 10);
        if (!/^\d{4}-\d{2}-\d{2}$/.test(reg) || !/^\d{4}-\d{2}-\d{2}$/.test(start)) return false;
        return reg >= start;
    }

    typeLabel(t: string): string { return HomeComponent.TYPE_LABEL[t] || t; }
    // 用方法而非直接比較 now!=='9':Angular strictTemplates 在 *ngIf="now=='0'" 大區塊
    // 之後緊接著的 now!=='9' 字面比較會誤判成「型別不重疊、恆真」(TS2367)。方法回傳
    // 一般 boolean,不會觸發這個樣板型別窄化怪癖。
    isTab9(): boolean { return this.now === '9'; }
    categoryLabel(cat: string): string { return HomeComponent.CATEGORY_LABEL[cat] || cat || '-'; }
    categoryColor(cat: string): string { return HomeComponent.CATEGORY_COLOR[cat] || HomeComponent.CATEGORY_COLOR.other; }
    // 名單顯示用「暱稱(uid)」;查無暱稱/uid(舊資料或帳號已刪)就退回顯示數字 user_id。
    displayName(f: any): string {
        const nick = f && f.nickname ? String(f.nickname).trim() : '';
        const uid = f && f.uid ? f.uid : '';
        if (nick && uid) return `${nick}(${uid})`;
        if (nick) return nick;
        if (uid) return `(${uid})`;
        return 'UID ' + (f ? f.user_id : '?');
    }

    // 營運分析:分析後端「固定」在 talkmate.tw(正式資料源,42萬用戶),與本後台 serverurl
    // (environment.prod 指向的 linode-voxy 小站)無關。httptype:1 → 攔截器保留此絕對網址、
    // 只注入 token;dbtool endpoint 已開 CORS(Allow-Origin:*),兩站共用 JWT 密鑰故 token 通用。
    loadAnalysis() {
        this.analysis_loading = true;
        const url = "https://www.talkmate.tw/agent/dbtool_get_analysis.php";
        this.httpClient.post<any>(url, { httptype: 1, limit: 20, with_flags: true }).subscribe(
            (res) => {
                this.analysis_loading = false;
                if (res && res.status) {
                    const reports = res.reports || [];
                    for (const r of reports) {
                        r.flagsChartOptions = this.buildFlagsChartOptions(r);
                        this.decorateReport(r);
                    }
                    this.analysis_reports = reports;
                }
            },
            () => {
                this.analysis_loading = false;
            }
        );
    }

    // 名單分數圖:只畫「價值用戶」兩類(男=本期消費額、女=本期收益額,同單位「元」可同軸比較)。
    // 其他類別(沉睡=歷史儲值、快閃=元/天、衰減=降幅)單位不同,混排會說出單位錯亂的故事,
    // 動能類的視覺化交給大戶儀錶板。沒有可用分數就回 null,卡片上直接不畫圖。
    private buildFlagsChartOptions(r: any): any {
        // score 從後端(MySQL DECIMAL 經 PDO)回來是字串如 "211055.00",Highcharts 的
        // series.data 收到字串會直接丟 error #14、整張圖不畫;這裡統一轉成 Number。
        const flags: any[] = (r.flags || [])
            .filter((f: any) => f && (f.category === 'value_male' || f.category === 'value_female'))
            .map((f: any) => ({ ...f, score: f && f.score !== null && f.score !== undefined ? Number(f.score) : null }))
            .filter((f: any) => f.score !== null && !isNaN(f.score));
        const sorted = flags.sort((a, b) => b.score - a.score).slice(0, 15)
            .map(f => ({ ...f, displayName: this.displayName(f) }));
        if (!sorted.length) return null;

        return {
            chart: { type: 'bar', height: Math.max(140, sorted.length * 26) },
            title: { text: null },
            credits: { enabled: false },
            legend: { enabled: false },
            xAxis: { categories: sorted.map(f => f.displayName), title: { text: null } },
            yAxis: { title: { text: null }, allowDecimals: false },
            tooltip: {
                formatter: function () {
                    const f = sorted[this.point.index];
                    return `<b>${f.displayName}</b>：${chartdata.thousandSeparator(f.score)}<br>${f.reason || ''}`;
                },
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
                        formatter: function () { return Highcharts.numberFormat(this.y, 0, '.', ','); },
                    },
                },
            },
            series: [{
                name: '分數',
                data: sorted.map(f => ({
                    y: f.score,
                    color: HomeComponent.CATEGORY_COLOR[f.category] || HomeComponent.CATEGORY_COLOR.other,
                })),
            }],
        };
    }

    private static escapeHtml(s: string): string {
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // 把內文中的 user_id 數字換成「暱稱(uid)」履歷頁連結,樓下行銷才知道是哪個用戶。
    // 只替換「4 位數以上、且有名單對照」的 id,前後不得緊鄰數字(避免切到金額/日期);
    // plainText=true 先做 HTML 轉義(LLM 條列文字),summary_md 本身是 HTML 則不轉義。
    //
    // 報告原文寫的是「編號 12345」,數字換成暱稱後會變成「編號 杰(AMC2SXN6QLF1)」,
    // 「編號」兩個字接一個人名很怪,所以 id 前面若緊鄰「編號」(可帶冒號/空白)就一起吃掉。
    // 做在這裡而不是改報告產生端:報告是外部工具產出後存起來的,改產生端救不了已經存在的舊報告。
    // 「編號」後面沒接到名單內的 id 時整條規則不成立,那兩個字原樣保留(例如「訂單編號」不受影響)。
    private linkifyIds(text: string, map: { [id: string]: any }, plainText: boolean): string {
        let t = plainText ? HomeComponent.escapeHtml(text || '') : String(text || '');
        const ids = Object.keys(map).filter(id => id.length >= 4).sort((a, b) => b.length - a.length);
        if (!ids.length) return t;
        try {
            const re = new RegExp('(?:編號\\s*[:：]?\\s*)?(?<![\\d])(' + ids.join('|') + ')(?![\\d])', 'g');
            t = t.replace(re, (_m: string, idStr: string) => {
                const info = map[idStr];
                const nick = info && info.nickname ? String(info.nickname).trim() : '';
                const uid = info && info.uid ? info.uid : '';
                const name = nick && uid ? `${nick}(${uid})` : (nick || (uid ? `(${uid})` : idStr));
                const label = HomeComponent.escapeHtml(name);
                return uid ? `<a href="${environment.link}/user/${uid}" target="_blank">${label}</a>` : label;
            });
        } catch (e) { /* 瀏覽器不支援 lookbehind 就保留原文,不影響其他功能 */ }
        return t;
    }

    // 把一份報告加工成前端要的形狀:運營面圖表(全部來自 DuckDB 確定性數字,非 LLM)、
    // 大戶動能儀錶板分組、留存表合併、四張卡與 summary 的 user_id → 暱稱(uid) 連結替換。
    private decorateReport(r: any) {
        const sj = r.summary_json || {};
        const ph = sj.platform_health || null;
        r.ph = ph;
        r.headline = sj.headline || null;

        // ── user_id → 暱稱(uid) 對照(flags + 大戶儀錶板都有後端補好的 uid/nickname) ──
        const map: { [id: string]: any } = {};
        for (const f of (r.flags || []))
            if (f.user_id !== null && f.user_id !== undefined) map[String(f.user_id)] = f;
        const whales: any[] = sj.whale_dashboard || [];
        for (const w of whales)
            if (w.user_id !== null && w.user_id !== undefined && !map[String(w.user_id)]) map[String(w.user_id)] = w;

        r.diffHtml = (sj.difficulties || []).map((x: string) => this.linkifyIds(x, map, true));
        r.imprHtml = (sj.improvements || []).map((x: string) => this.linkifyIds(x, map, true));
        r.follHtml = (sj.follow_ups || []).map((x: string) => this.linkifyIds(x, map, true));
        r.recoHtml = (sj.recommendations || []).map((x: string) => this.linkifyIds(x, map, true));
        r.summaryHtml = r.summary_md ? this.linkifyIds(r.summary_md, map, false) : null;

        // ── 大戶動能儀錶板分組(高成長/衰退/新進/沉睡) ──
        // 每列掛上該用戶的 AI 判讀(儀錶板列「查看」按鈕展開);AI 判讀名單獨立表
        // 則只列「儀錶板未涵蓋」的對象(女性收益用戶、動能穩定的男大戶等),避免重複。
        const flagsByUser: { [id: string]: any[] } = {};
        for (const f of (r.flags || []))
            if (f.user_id !== null && f.user_id !== undefined)
                (flagsByUser[String(f.user_id)] = flagsByUser[String(f.user_id)] || []).push(f);
        const whaleIds: { [id: string]: boolean } = {};
        for (const w of whales) {
            whaleIds[String(w.user_id)] = true;
            w.aiFlags = flagsByUser[String(w.user_id)] || [];
            w.showAi = false;
        }
        r.aiOnlyFlags = (r.flags || []).filter((f: any) =>
            f.user_id === null || f.user_id === undefined || !whaleIds[String(f.user_id)]);

        const order = ['whale_growth', 'whale_decline', 'whale_new', 'whale_dormant'];
        r.whaleGroups = order
            .map(k => ({ key: k, label: this.whaleLabel(k), color: this.whaleColor(k), rows: whales.filter(w => w.category === k) }))
            .filter(g => g.rows.length > 0);

        if (!ph) return;

        // ── 運營面圖表 ──
        const od: any[] = ph.overview_daily || [];
        // 「資料完整到哪天」由後端算好(data_complete_through);舊報告沒有這欄時退回用
        // 報告產生日推。凡是超過完整日的末點都標「(未結)」——當日只累計到抓取那一刻。
        const completeThrough = ph.data_complete_through || null;
        const genDay = String(r.generated_at || '').slice(0, 10);
        const isUnsettled = (rawDate: any) => {
            const d = String(rawDate).slice(0, 10);
            return completeThrough ? d > String(completeThrough) : d === genDay;
        };
        // 用完整日期字串比對(不可拿 slice(5) 後的 MM-DD 比,跨年會誤判)
        const labelsOf = (rows: any[], pick: (x: any) => string) => {
            const out = rows.map(pick);
            if (rows.length && isUnsettled(rows[rows.length - 1].date)) out[out.length - 1] += '(未結)';
            return out;
        };
        const dates = labelsOf(od, x => String(x.date).slice(5));
        const mk = (series: any[], opts: any = {}) => ({
            chart: { type: 'line', height: 230 },
            title: { text: null }, credits: { enabled: false },
            xAxis: { categories: opts.categories || dates, labels: { step: Math.max(1, Math.ceil((opts.categories || dates).length / 10)) } },
            yAxis: { title: { text: opts.yTitle || null }, allowDecimals: false, min: 0 },
            tooltip: { shared: true },
            plotOptions: { series: { marker: { enabled: false } } },
            series,
        });
        if (od.length) {
            // 男女「分開兩張圖」:男性量體是女性的 8~10 倍,同軸疊圖時女性曲線
            // 會被壓成貼地直線、完全看不出變化量,分圖各自用自己的量級刻度。
            r.regChartM = mk([{ name: '男', data: od.map(x => x.new_male), color: '#2f6fed' }], { yTitle: '註冊數' });
            r.regChartF = mk([{ name: '女', data: od.map(x => x.new_female), color: '#e0559b' }], { yTitle: '註冊數' });
            r.activeChartM = mk([{ name: '男', data: od.map(x => x.active_male), color: '#2f6fed' }], { yTitle: '登入人數' });
            r.activeChartF = mk([{ name: '女', data: od.map(x => x.active_female), color: '#e0559b' }], { yTitle: '登入人數' });
            r.revenueChart = mk([
                { name: '儲值額', type: 'column', data: od.map(x => x.deposit_twd), color: '#2f9e58' },
                { name: '提領額', data: od.map(x => x.withdrawal_twd), color: '#8a93a6' },
            ], { yTitle: '元' });
            r.payersChart = mk([
                { name: '付費人數', data: od.map(x => x.paying_users), color: '#b8860b' },
                { name: '付費次數', data: od.map(x => x.deposit_times), color: '#8a93a6' },
            ], { yTitle: '人 / 次' });
        }
        const tsw: any[] = ph.topshare_weekly || [];
        if (tsw.length) {
            r.topshareChart = mk([
                { name: '前1%', data: tsw.map(x => x.top1_pct), color: '#2f6fed' },
                { name: '前5%', data: tsw.map(x => x.top5_pct), color: '#e2703a' },
                { name: '前10%', data: tsw.map(x => x.top10_pct), color: '#b8860b' },
            ], { categories: tsw.map(x => String(x.week_start).slice(0, 10)), yTitle: '占總儲值額 %' });
        }

        // ── 留存表:各來源依 D-n 合併成一列;兩種口徑各一份 ──
        //    dn = 「N 天內」累計、day_n = 「第 N 天」單日(第 1 天 = 註冊當天)
        const mergeRetention = (suffix: string) => {
            const byN: { [n: number]: any } = {};
            const rowOf = (n: number) => (byN[n] = byN[n] || { n });
            for (const x of (ph['retention_male_spend_' + suffix] || [])) { const row = rowOf(x.n); row.spend_pct = x.pct; row.eligible = x.eligible; }
            for (const x of (ph['revenue_pay_' + suffix] || [])) rowOf(x.n).pay_pct = x.pct;
            for (const x of (ph['retention_login_male_' + suffix] || [])) rowOf(x.n).m_login = x.pct;
            for (const x of (ph['retention_login_female_' + suffix] || [])) rowOf(x.n).f_login = x.pct;
            for (const x of (ph['retention_interact_male_' + suffix] || [])) { const row = rowOf(x.n); row.m_chat = x.chat_pct; row.m_call = x.call_pct; }
            for (const x of (ph['retention_interact_female_' + suffix] || [])) { const row = rowOf(x.n); row.f_chat = x.chat_pct; row.f_call = x.call_pct; row.f_eligible = x.eligible; }
            return Object.keys(byN).map(k => byN[+k]).sort((a: any, b: any) => a.n - b.n);
        };
        r.retentionRows = mergeRetention('dn');
        r.retentionRowsDay = mergeRetention('day_n');

        // ── 世代分群(cohort)網格:列=註冊週、欄=第0..N週,值=該週有登入% ──
        //    後端逐用戶判斷觀察期,樣本不足一半的格子不給。給的格子帶:
        //      eligible     = 實際分母(已滿觀察期的人數)
        //      cohort_size  = 整個世代人數
        //      provisional  = 兩者不等 → 這格是暫定值,之後會小幅變動
        //      reg_from/to/reg_days = 這一列實際涵蓋的註冊日(第一列常被期間起日切成半週)
        // 用 UTC 做日期加減,避免本機時區把日界推移一天(台灣 UTC+8 會少一天)
        const addDays = (iso: string, n: number) => {
            const d = new Date(iso + 'T00:00:00Z');
            d.setUTCDate(d.getUTCDate() + n);
            return d.toISOString().slice(0, 10);
        };
        const pivotCohort = (rows: any[]) => {
            if (!rows || !rows.length) return null;
            const by: { [c: string]: any } = {};
            let maxW = 0;
            for (const x of rows) {
                const cw = String(x.cohort_week).slice(0, 10);
                by[cw] = by[cw] || { cohort: cw, size: 0, cells: {}, els: {}, prov: {} };
                const row = by[cw];
                row.cells[x.week_n] = x.pct;
                row.els[x.week_n] = x.eligible;
                row.prov[x.week_n] = !!x.provisional;
                // 人數用整個世代(cohort_size);舊報告沒這欄時退回用 eligible 最大值
                row.size = Math.max(row.size, x.cohort_size || x.eligible || 0);
                if (x.reg_from) { row.regFrom = x.reg_from; row.regTo = x.reg_to; row.regDays = x.reg_days; }
                if (x.week_n > maxW) maxW = x.week_n;
            }
            const out = Object.keys(by).sort().map(k => by[k]);
            const weeks = Array.from({ length: maxW + 1 }, (_, i) => i);
            // 空格 = 連一半的人都還沒過完那一週。暫定格 = 過半但還沒全滿。
            // 兩者都算出「整批人都過完的日期」= 最晚註冊者(註冊週週日)的第 w 週結束日;
            // 註冊週每往後 7 天、要求的週數就少 1 → 各列最近的一格恰好同一天到期,
            // 所以整條斜線會一次定案,nextFill 就是那一天。
            let nextFill: string | null = null;
            out.forEach(row => {
                // 分母不一致在「暫定格」是正常的(觀察期未滿);只有已定案的格子之間
                // 不一致才是異常,那才該標紅——否則每一列都會掛警告,警告就沒意義了。
                const settled = weeks.filter(w => row.cells[w] != null && !row.prov[w])
                    .map(w => row.els[w]).filter((v: any) => v != null);
                row.mixed = new Set(settled).size > 1;
                // 半週:被報表期間起日切掉的第一列,人數不可與其他列橫向比較
                row.partialWeek = row.regDays != null && row.regDays < 7;
                row.lastReg = addDays(row.cohort, 6);
                row.ready = {};
                for (const w of weeks) {
                    if (row.cells[w] != null && !row.prov[w]) continue;   // 已定案
                    const d = addDays(row.lastReg, (w + 1) * 7 - 1);
                    row.ready[w] = d;
                    if (!nextFill || d < nextFill) nextFill = d;
                }
                // 一個人等於幾個百分點——女性世代每週僅數十人,0% 可能只是「剛好沒人」
                row.ppPerPerson = {};
                // 暫定值最多還會移動幾個百分點:未過完的人若全部翻面的上限。
                // 不寫死成「1 個百分點內」——那是拿男性表(分母數百)量出來的,
                // 女性分母只有數十人時實測會差到 2.3pp,寫死就是給錯的保證。
                row.maxShift = {};
                for (const w of weeks) {
                    const n = row.els[w];
                    if (!n) continue;
                    row.ppPerPerson[w] = Math.round(1000 / n) / 10;
                    if (row.prov[w] && row.size) row.maxShift[w] = Math.round((row.size - n) * 1000 / row.size) / 10;
                }
            });
            return { weeks, rows: out, nextFill };
        };
        r.cohortM = pivotCohort(ph.cohort_login_weekly_male);
        r.cohortF = pivotCohort(ph.cohort_login_weekly_female);
        r.dataThrough = completeThrough;             // cohort 說明要講「目前資料到哪天」

        // ── LTV / MAU / ARPDAU 圖 ──
        const ltv: any[] = ph.ltv_curve_male || [];
        if (ltv.length) {
            r.ltvChart = mk([{ name: '人均累計儲值(元)', data: ltv.map(x => x.ltv_per_user), color: '#2f9e58' }],
                { categories: ltv.map(x => '第' + x.n + '天'), yTitle: '元 / 人' });
            r.ltvCohortSize = ltv[0].eligible;          // 固定世代人數(各 n 相同)
            r.ltvRegDays = ltv[0].cohort_reg_days;      // 世代涵蓋幾個註冊日
        }
        // MAU 是滾動指標,末點未結時少一天不影響判讀 → 直接不畫,比標注更乾淨
        const trimUnsettled = (rows: any[]) =>
            rows.length && isUnsettled(rows[rows.length - 1].date) ? rows.slice(0, -1) : rows;
        const mauM: any[] = trimUnsettled(ph.mau_rolling30_male || []);
        if (mauM.length)
            r.mauChartM = mk([{ name: 'MAU(男)', data: mauM.map(x => x.mau), color: '#2f6fed' }],
                { categories: mauM.map(x => String(x.date).slice(5)), yTitle: '人' });
        const mauF: any[] = trimUnsettled(ph.mau_rolling30_female || []);
        if (mauF.length)
            r.mauChartF = mk([{ name: 'MAU(女)', data: mauF.map(x => x.mau), color: '#e0559b' }],
                { categories: mauF.map(x => String(x.date).slice(5)), yTitle: '人' });
        // 首充/次充率的週趨勢(後端本來就算了,之前只餵給 AI、沒畫出來)
        const prw: any[] = ph.pay_rates_weekly || [];
        if (prw.length > 1)
            r.payRateChart = mk([
                { name: '首充率 %', data: prw.map(x => x.first_pay_rate_pct), color: '#2f6fed' },
                { name: '次充率 %', data: prw.map(x => x.second_pay_rate_pct), color: '#b8860b' },
            ], { categories: prw.map(x => String(x.week_start).slice(0, 10)), yTitle: '%' });
        const arp: any[] = ph.arpdau_daily || [];
        if (arp.length)
            r.arpdauChart = mk([{ name: 'ARPDAU(元/官方登入人數/日)', data: arp.map(x => x.arpdau), color: '#b8860b' }],
                { categories: labelsOf(arp, x => String(x.date).slice(5)), yTitle: '元' });

        r.payRates = (ph.pay_rates || [])[0] || null;
        r.perPayer = (ph.revenue_per_payer || [])[0] || null;
        r.payerPop = (ph.payer_population || [])[0] || null;
        r.engMale = (ph.engagement_avg_male || [])[0] || null;
        r.engFemale = (ph.engagement_avg_female || [])[0] || null;
        // 後端 notes(口徑說明、覆蓋不足、被略過的本地檔…)以前只餵給 AI,前端從不顯示
        // → 「圖表消失」和「查詢失敗」分不出來。這裡撈出來,底部摺疊區呈現。
        r.notes = (r.summary_json && r.summary_json.notes) || sj.notes || null;
    }

    callback(pageobj: page) {
        if (JSON.stringify(this.pageobj) != JSON.stringify(pageobj)) {
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    callback2(pageobj: page) {
        if (JSON.stringify(this.pageobj2) != JSON.stringify(pageobj)) {
            this.pageobj2 = pageobj;
            this.fuck_view(this.tmd_para.time_id, this.tmd_para.action);
        }
    }

    callback3(pageobj: page) {
        if (JSON.stringify(this.pageobj3) != JSON.stringify(pageobj)) {
            this.pageobj3 = pageobj;
            this.openNoMsgWhaleModal();
        }
    }

    fresh() {
        this.init_list(1);
    }

    get anyRefreshing(): boolean {
        return Array.isArray(this.info) && this.info.some((it: any) => it && it.__refreshing);
    }

    refreshAllRealtimeStats(force = false) {
        if (!Array.isArray(this.info) || this.info.length === 0) return;
        this.info.forEach((it: any) => it.__refreshing = true);
        const date_types = this.info.map((it: any) => it.time_id);
        const body: any = { date_types };
        if (force) body.force_realtime = true;
        this.httpClient.post<any>("/v1/common/get_realtime_login_stats.php", body).subscribe(
            (res) => {
                this.info.forEach((it: any) => it.__refreshing = false);
                if (res && res.status && res.data) {
                    this.info.forEach((it: any) => {
                        const d = res.data[String(it.time_id)];
                        if (d) this.applyRealtimeStats(it, d);
                    });
                }
            },
            (err) => {
                this.info.forEach((it: any) => it.__refreshing = false);
                console.log(err);
            }
        );
    }

    refreshLoginStats(item: any, ev?: Event) {
        if (ev) {
            ev.stopPropagation();
            ev.preventDefault();
        }
        item.__refreshing = true;
        const body = { date_type: item.time_id, force_realtime: true };
        this.httpClient.post<any>("/v1/common/get_realtime_login_stats.php", body).subscribe(
            (res) => {
                item.__refreshing = false;
                if (res && res.status && res.data) {
                    this.applyRealtimeStats(item, res.data);
                }
            },
            (err) => {
                item.__refreshing = false;
                console.log(err);
            }
        );
    }

    private applyRealtimeStats(item: any, d: any) {
        item.login_male_nums      = d.online_male;
        item.login_female_nums    = d.online_female;
        item.male_count           = d.silent_male;
        item.female_count         = d.silent_female;
        item.text_user_num_male   = d.msg_users_male;
        item.text_user_num_female = d.msg_users_female;
        item.text_num_male        = d.msg_count_male;
        item.text_num_female      = d.msg_count_female;
        item.msg_count_real_male      = d.msg_count_real_male;
        item.msg_count_real_female    = d.msg_count_real_female;
        item.msg_count_mass_male      = d.msg_count_mass_male;
        item.msg_count_mass_female    = d.msg_count_mass_female;
        item.msg_users_only_real_male   = d.msg_users_only_real_male;
        item.msg_users_only_real_female = d.msg_users_only_real_female;
        item.msg_users_only_mass_male   = d.msg_users_only_mass_male;
        item.msg_users_only_mass_female = d.msg_users_only_mass_female;
        item.msg_users_both_male        = d.msg_users_both_male;
        item.msg_users_both_female      = d.msg_users_both_female;
    }

    count_ratio(target_key, arr_key, arr) {
        let all = 0;
        for (let i in arr_key) {
            all += arr[arr_key[i]] * 1;
        }
        return Math.round((arr[target_key] / all) * 10000) / 100.0;
    }
}
